import { listSubCategoryDropdown } from "../../../api/actions/category";
const userData = JSON.parse(localStorage.getItem("user_info"));
let typingSubcategory;

export const subcategoryLoadOptionHandler = (inputValue, formik,setSubcategory,fromCollection) => {
  // 🚫 If no primary category selected, show no options — no loading
  if (fromCollection) {
    // If from collection, ensure category exists
    if (!formik?.values?.category) {
      return Promise.resolve([]);
    }
  } else {
    // If not from collection, ensure primary_category exists
    if (!formik?.values?.primary_category?.length) {
      return Promise.resolve([]);
    }
  }


  // ✅ Otherwise proceed normally
  return new Promise((resolve) => {
    clearTimeout(typingSubcategory);

    typingSubcategory = setTimeout(() => {
      if (inputValue?.length >= 1) {
        listSubCategoryDropdown({
          page: 1,
          search: inputValue,
          museum_id: userData?.museum,
          is_primary: false,
          sort_by: "category_name",
          primary_category: formik?.values?.primary_category||formik?.values?.category,
        })((response) => {
          if (response?.status) {
            setSubcategory(response?.data);
            resolve(response?.data);
          } else {
            resolve([]);
          }
        });
      } else {
        resolve([]);
      }
    }, 300);
  });
};
